import { Typography, Divider, Box } from '@mui/material'

interface ContainerCheckboxProps {
  label: string
  children?: React.ReactNode;
  inlined?: boolean;
  testId?: string;
}

const ContainerCheckbox = ({
  label,
  children,
  inlined = false,
  testId,
} : ContainerCheckboxProps) => (inlined ? (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
    }}
    data-testid={testId}
  >
    <Typography sx={{ padding: '0 0 0 .8rem' }}>{ label }</Typography>
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        padding: '0 0 0 .4rem',
        marginTop: '-.5rem',
      }}
    >
      { children }
    </Box>
  </Box>
) : (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: '1.4rem',
    }}
    data-testid={testId}
  >
    <Typography sx={{ padding: '0 0 0 .8rem' }}>{ label }</Typography>
    <Divider flexItem variant='middle' />
    <Box sx={{ display: 'flex', flexWrap: 'wrap', padding: '0 0 0 .2rem' }}>
      { children }
    </Box>
  </Box>
))

export default ContainerCheckbox
